import { type ContextSource } from '~/components/v2/types/contextSources';

/**
 * Locate a value's parent field by matching the value id. The API does not populate
 * `contextSourceFieldId` on nested values (the type claims it, but it's absent at runtime),
 * so a direct `field.id === value.contextSourceFieldId` lookup returns undefined — match on
 * `value.id` instead.
 */
export const findContextSourceFieldForValueId = (contextSource: ContextSource | undefined, valueId: string) => {
  return contextSource?.fields.find((field) => field.values?.some((value) => value.id === valueId));
};
